import React from 'react'
import { Html , useProgress }from '@react-three/drei'
import CustomizerContext from '../CustomizerContext';
import {ReactComponent as BrandLogo} from '../j4clogo.svg';


const Loading = (props) => {
    

    const loaded = useProgress((state) =>  state.progress === 100)

    if(loaded) {
        CustomizerContext.ui = true;
        CustomizerContext.mobileUi = true;
    }
    

    return (
        <Html center>
            
            <BrandLogo className="animate-bounce" width={128} />

        </Html> 
    )
    
}

export default Loading